import { AgGridCustomFilterAdapter } from 'components/CustomTableFilter';

import { useMemo } from 'react';

import {
    bimPriceRowAnalyticsCodeFilterGql,
    bimPriceRowAnalyticsNameFilterGql,
    bimPriceRowAnalyticsSectionFilterGql,
    bimPriceRowAnalyticsSubsectionFilterGql,
    bimPriceRowAnalyticsUnitFilterGql,
} from '../bimWorkOrderPriceAnalyticsQueries';
import type { TFiltersChangeHandler, TProps } from '../types';

export const useAnalyticsTableFilters = ({
    workOrderPriceId,
    refWorkOrderPriceId,
    changeFiltersHandler,
}: Omit<TProps, 'priceLevel'> & TFiltersChangeHandler) => {
    const variables = useMemo(
        () => ({
            workOrderPriceId,
            refWorkOrderPriceId,
        }),
        [refWorkOrderPriceId, workOrderPriceId],
    );

    const filterAvailable = useMemo(
        () => Boolean(workOrderPriceId && refWorkOrderPriceId),
        [refWorkOrderPriceId, workOrderPriceId],
    );

    return useMemo(
        () => ({
            section: {
                filter: filterAvailable ? AgGridCustomFilterAdapter : undefined,
                filterParams: {
                    hideTableHeader: true,
                    variables,
                    query: bimPriceRowAnalyticsSectionFilterGql,
                    dataAccessor: 'bimPriceRowAnalyticsSectionFilter',
                    childFieldAccessor: 'value',
                    whereVariables: ['value'],
                    changeFilterHandler: changeFiltersHandler,
                    columns: [
                        {
                            checkboxSelection: true,
                            headerName: 'Раздел',
                            field: 'value',
                            lockVisible: true,
                            flex: 1,
                        },
                    ],
                },
            },
            subsection: {
                filter: filterAvailable ? AgGridCustomFilterAdapter : undefined,
                filterParams: {
                    hideTableHeader: true,
                    variables,
                    query: bimPriceRowAnalyticsSubsectionFilterGql,
                    dataAccessor: 'bimPriceRowAnalyticsSubsectionFilter',
                    childFieldAccessor: 'value',
                    whereVariables: ['value'],
                    changeFilterHandler: changeFiltersHandler,
                    columns: [
                        {
                            checkboxSelection: true,
                            headerName: 'Раздел',
                            field: 'value',
                            lockVisible: true,
                            flex: 1,
                        },
                    ],
                },
            },
            code: {
                filter: filterAvailable ? AgGridCustomFilterAdapter : undefined,
                filterParams: {
                    hideTableHeader: true,
                    variables,
                    query: bimPriceRowAnalyticsCodeFilterGql,
                    dataAccessor: 'bimPriceRowAnalyticsCodeFilter',
                    childFieldAccessor: 'value',
                    whereVariables: ['value'],
                    changeFilterHandler: changeFiltersHandler,
                    columns: [
                        {
                            checkboxSelection: true,
                            headerName: 'Раздел',
                            field: 'value',
                            lockVisible: true,
                            flex: 1,
                        },
                    ],
                },
            },
            name: {
                filter: filterAvailable ? AgGridCustomFilterAdapter : undefined,
                filterParams: {
                    hideTableHeader: true,
                    variables,
                    query: bimPriceRowAnalyticsNameFilterGql,
                    dataAccessor: 'bimPriceRowAnalyticsNameFilter',
                    childFieldAccessor: 'value',
                    whereVariables: ['value'],
                    changeFilterHandler: changeFiltersHandler,
                    columns: [
                        {
                            checkboxSelection: true,
                            headerName: 'Раздел',
                            field: 'value',
                            lockVisible: true,
                            flex: 1,
                        },
                    ],
                },
            },
            unit: {
                filter: filterAvailable ? AgGridCustomFilterAdapter : undefined,
                filterParams: {
                    hideTableHeader: true,
                    variables,
                    query: bimPriceRowAnalyticsUnitFilterGql,
                    dataAccessor: 'bimPriceRowAnalyticsUnitFilter',
                    childFieldAccessor: 'value',
                    whereVariables: ['value'],
                    changeFilterHandler: changeFiltersHandler,
                    columns: [
                        {
                            checkboxSelection: true,
                            headerName: 'Раздел',
                            field: 'value',
                            lockVisible: true,
                            flex: 1,
                        },
                    ],
                },
            },
        }),
        [changeFiltersHandler, filterAvailable, variables],
    );
};
